import { FC, useEffect } from 'react';
import { IndeterminateSpinner } from '@ebsco-ui/ebsco-ui';

import { useAppContext } from '@app/contexts';
import { useQueryParams } from '@app/hooks';
import { SSO_REDIRECT_ROUTE_KEY } from '@app/constants';

import css from './SSOPage.module.scss';

export const SSOPage: FC = () => {
  const { ssoToken } = useQueryParams();
  const { authenticateToken } = useAppContext();

  useEffect(() => {
    if (ssoToken) {
      authenticateToken(
        ssoToken as string,
        sessionStorage.getItem(SSO_REDIRECT_ROUTE_KEY) ?? ''
      );

      sessionStorage.removeItem(SSO_REDIRECT_ROUTE_KEY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={css.spinner} data-auto="spinner">
      <IndeterminateSpinner level="page" />
    </div>
  );
};
